import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconClapboardWide: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="clapboard-wide, movie, film"><path d="M21.25 4.75H2.75V19.25H21.25V4.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M3 9.75H21" stroke="currentColor" strokeWidth="1.5"/><path d="M7.75 9.75L9.75 4.75" stroke="currentColor" strokeWidth="1.5"/><path d="M14.25 9.75L16.25 4.75" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconClapboardWide;
